export default __webpack_public_path__ + "static/media/unarchive.a6cabb3a.svg";